import React, { Component } from 'react';
import styled from 'styled-components';
import logo from '../assets/logo-red.png';

const Container = styled.div`
  margin-top: 1rem;
`;

const Logo = styled.img`
  height: 20px;
  width: auto;
  margin-bottom: 0.5rem;
`;

class Footer extends Component {
  getYear = () => (new Date()).getFullYear();

  render() {
    return (
      <footer className="footer mt-auto py-3">
        <Container className="container text-center">
          <Logo src={logo} />
          <br />
          <span className="text-muted">
            Copyright {this.getYear()} © OAKHOUSE All Right Reserved.
          </span>
        </Container>
      </footer>
    );
  }
}

export default Footer;
